import axios from "axios";
import {soNumeros} from "@/helps/util";

export function locEmpresa(cnpj) {
    return new Promise((resolve, reject) => {
        axios.get(`https://publica.cnpj.ws/cnpj/${soNumeros(cnpj)}`, {}).then((res) => {
            resolve(res)
        }).catch(error => {
            reject(error)
        });
    })
}

